import React from 'react';
import { Typography } from 'antd';
import type { PersonalReportSummaryJson } from '../../data/mockPersonalReportSummary';
import { coreConclusion, formatTenure, nineBoxLabel } from './shared';

export function EmployeeProfileCard({
  data,
  titleSuffix,
}: {
  data: PersonalReportSummaryJson;
  titleSuffix?: string;
}) {
  const { emp } = data;
  const nb = emp.nineBoxResults?.[0];
  const finalCell = nb?.finalCell != null ? String(nb.finalCell) : null;
  const talentLabel = finalCell ? nineBoxLabel(finalCell) : null;
  const hp = emp.highPotentialAsEvaluatee?.[0];
  const hpLabel = hp?.resultLabel != null ? String(hp.resultLabel) : null;
  const conclusion = finalCell ? coreConclusion(finalCell, hpLabel) : null;
  const showJudgment = !!(finalCell && talentLabel);

  const tenure = formatTenure(emp.hireDate);
  const deptParts = (emp.deptPath ?? '').split('/').map((s) => s.trim()).filter(Boolean);
  const company = deptParts[0] ?? null;
  const department = deptParts.length > 1 ? deptParts.slice(1).join(' / ') : null;
  const initial = (emp.name?.trim()[0] ?? '?').toUpperCase();

  return (
    <section id="profile" className="report-profile-card" aria-label="员工画像">
      <div className="report-profile-main">
        <div className="report-profile-avatar" aria-hidden>
          {initial}
        </div>
        <div className="report-profile-identity">
          <div className="report-profile-name-row">
            <Typography.Title level={3} className="report-profile-name">
              {emp.name}
              {emp.position ? (
                <span className="report-profile-position">· {emp.position}</span>
              ) : null}
            </Typography.Title>
            {titleSuffix ? (
              <Typography.Text className="report-profile-suffix">{titleSuffix}</Typography.Text>
            ) : null}
          </div>
          <div className="report-profile-org">
            {company ? <span>{company}</span> : null}
            {department ? (
              <>
                {company ? <span className="report-profile-sep">/</span> : null}
                <span>{department}</span>
              </>
            ) : null}
            {!company && !department ? <span>—</span> : null}
          </div>
          {tenure ? (
            <div className="report-profile-tenure">工龄 {tenure}</div>
          ) : null}
        </div>
      </div>

      {showJudgment ? (
        <div className="report-profile-judgment" aria-label="人才判断">
          <div className="report-judgment-kicker">人才判断</div>
          <div className="report-judgment-type">{talentLabel}</div>
          {conclusion ? (
            <div className="report-judgment-conclusion">{conclusion}</div>
          ) : null}
          <div className="report-judgment-caption">规则判定</div>
        </div>
      ) : null}
    </section>
  );
}
